import { setUser } from '@sentry/react';

/**
 * Attributes subsequent events to a user by opaque id, or clears attribution
 * when passed `null`.
 *
 * ID ONLY. `email`, `username` and `ip_address` are all constituent-adjacent
 * PII, and `sendDefaultPii: false` only stops the SDK from *inferring* them —
 * it does not stop a caller setting them explicitly. Without this, every issue
 * reports `Users: 0` and blast radius cannot be ranked; with anything more than
 * the id, the issue stream becomes a PII sink.
 */
export function setSentryUser(userId: string | null): void {
  setUser(userId === null ? null : { id: userId });
}
